// this code is generated automatically, don't modify manually;
export const CoinbaseLogoIcon = ({ boxSize }: { boxSize?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2500 2500"
    width={boxSize || 38}
    height={boxSize || 38}
  >
    <g>
      <g>
        <g>
          <g>
            <circle cx="1250" cy="1250" r="1250" fill="#fff" />
            <path
              d="M1250.4 1689.5c-242.8 0-439.4-196.7-439.4-439.5s196.7-439.4 439.4-439.4c217.5 0 398.1 158.6 432.9 366.2H2126c-37.4-451.2-414.9-805.7-875.6-805.7-485.2 0-878.9 393.7-878.9 878.9s393.7 878.9 878.9 878.9c460.7 0 838.3-354.5 875.6-805.7h-443.1c-34.8 207.7-215 366.3-432.5 366.3z"
              fill="#0052ff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
